import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpService } from './http.service';
import { EndPoint } from '../config/endpoint';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessagesService {
  constructor(private httpService: HttpService) {}

  async getMessageById(id) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Messages}/${id}`),
      );
    } catch (error) {
      throw error;
    }
  }

  async getLastMessageOfCurrentUser(queryParams) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.LastMessageOfCurrentUser}`, {
          params: queryParams,
        }),
      );
    } catch (error) {
      throw error;
    }
  }

  async getClassroomOrStudentsUsingRoleId(queryParams) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.users_by_role_id_classroom_id_messages}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async deleteMultipleMessages(body) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.DeleteMultipleMessages}`, body),
      );
    } catch (error) {
      throw error;
    }
  }

  async getMessageByUserAndReciever(queryParams) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Messages}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeTokenPaginationWithcondition(response);
    } catch (error) {
      throw error;
    }
  }

  async getArchivedUsersById(queryParams) {
    try {
      const response = await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Archive}`, {
          params: queryParams,
        }),
      );
      return this.httpService.decodeToken(response);
    } catch (error) {
      throw error;
    }
  }

  async deleteArchivedUser(id) {
    try {
      return firstValueFrom(this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.Archive}/${id}`));
    } catch (error) {
      throw error;
    }
  }

  async addArchiveUser(body) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.Archive}`, body),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async addMultipleMessages(body) {
    try {
      const multipleMessageToken = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.AddMultipleMessages}`, body),
      );

      return this.httpService.decodeToken(multipleMessageToken);
    } catch (error) {
      throw error;
    }
  }

  async addMessage(body) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.Messages}`, body),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async deleteMessage(id) {
    try {
      return await firstValueFrom(
        this.httpService.delete<any>(`${environment.XANO_SERVER_URL}${EndPoint.Messages}/${id}`),
      );
    } catch (error) {
      throw error;
    }
  }

  async updateMessage(id: number, body: object) {
    try {
      const response = await firstValueFrom(
        this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.Messages}/${id}`, body),
      );
      return this.httpService.decryptToken(response);
    } catch (error) {
      throw error;
    }
  }

  async addMessageMedia(formData) {
    const token = await firstValueFrom(
      this.httpService.post<any>(`${environment.XANO_SERVER_URL}${EndPoint.Messagemedia}`, formData),
    );
    return this.httpService.decodeTokenPagination(token);
  }

  async getMessageMediaById(id) {
    try {
      return await firstValueFrom(
        this.httpService.get<any>(`${environment.XANO_SERVER_URL}${EndPoint.Messagemedia}/${id}`),
      );
    } catch (error) {
      throw error;
    }
  }

  async sendEmail(data) {
    try {
      return await firstValueFrom(this.httpService.post<any>(`${environment.NODE_SERVER}${EndPoint.Email}`, data));
    } catch (error) {
      throw error;
    }
  }

  async sendBulkEmailToUsers(data) {
    try {
      return firstValueFrom(this.httpService.post<any>(`${environment.NODE_SERVER}${EndPoint.BulkEmail}`, data));
    } catch (error) {
      throw error;
    }
  }

  async deleteTrialUser(data) {
    try {
      return await firstValueFrom(
        this.httpService.post<any>(`${environment.NODE_SERVER}${EndPoint.delete_trial_user}`, data),
      );
    } catch (error) {
      throw error;
    }
  }
}
